(function () {
    const $ = require('jquery');
    const Bloodhound = require('bloodhound-js');
    require('typeahead.js');

    const source = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            wildcard: '%QUERY',
            rateLimitWait: 100,
            url: '/api/autocomplete/suburb?q=%QUERY',
        },
    });

    var $typeahead = $('.suburb-typeahead');
    $typeahead.typeahead({
        hint: false,
        minLength: 2,
        highlight: true,
    }, {
        limit: 12,
        source: source,
        display: 'display',
        templates: {
            pending: $('template#pending').html(),
            empty: $('template#empty').html(),
        },
    });

    $typeahead.bind('typeahead:select', function (e, suggestion) {
        $typeahead.typeahead('val', suggestion.display);
        $('#jsSuburbID').val(suggestion.value);
    });
}());
